import { useMemo } from "react";
import { CHAT_INIT_ARCHIVED } from "../../../../../lib/constants";
import { IMessage } from "../../../types/Message";

export const useDescBlock = (
  isArchived: boolean,
  initErr: string | null,
  data: IMessage[]
) => {
  return useMemo(() => {
    const info: any = {};

    if (initErr) {
      info.title = initErr;
    } else {
      info.title =
        isArchived && data.length === 0
          ? CHAT_INIT_ARCHIVED
          : "Start a direct conversation";

      if (!isArchived) {
        info.subTitle = "It will make the deal process smoother for everyone.";
      }
    }

    return info;
  }, [isArchived, initErr, data]);
};
